import { BucketContextProvider } from "context/bucket";
import { FC } from "react";
import { HomeLayout } from "./components";

export const HomePage: FC = () => {
  return (
    <BucketContextProvider>
      <HomeLayout />
    </BucketContextProvider>
  );
};
